// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KdURq","type":"styles_type__3DPsp","choices":"styles_choices__XhpK0"};